export function alternatingRowColor(index: number) {
  const backgroundColor = index % 2 ? '#fff3cd' : ''
  return { backgroundColor }
}

export function rowKey(row: {
  tree_id: string
  version_id: string
  node_id: string
}) {
  return [row.tree_id, row.version_id, row.node_id].join(':')
}
